import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import styled from 'styled-components';
import { LoadingSpinner } from 'wg-fe-ui';
import { retrieveAutomobileBrands } from '../legacy/services/apiRouterService';

interface Props {
  brand: string | undefined;
}

const BrandLogo: React.FC<React.PropsWithChildren<Props>> = ({ brand }) => {
  const [logoURL, setLogoURL] = useState();
  const { isLoading, data, isError } = useQuery(
    ['brandIcon', brand],
    () => retrieveAutomobileBrands(`q=${brand}`),
    {
      enabled: !!brand,
    },
  );

  useEffect(() => {
    if (data) {
      const _itm = data[0]?.items?.[0];
      if (_itm) setLogoURL(_itm?.brand?.logo_url);
    }
  }, [data]);

  if (isLoading || !logoURL) return <StyledLoadingSpinner />;
  if (isError) return <p>Error</p>;
  return <Logo src={logoURL} alt={`${brand} logo`} />;
};

const StyledLoadingSpinner = styled(LoadingSpinner)`
  min-width: 4rem;
  width: 4rem;
  height: 4rem;
  min-height: 4rem;
  transform-origin: 2rem 2rem 2rem;

  @media print {
    min-width: 6rem;
    width: 6rem;
    height: 6rem;
    min-height: 6rem;
  }
`;

const Logo = styled.img`
  height: 100%;
  width: 100%;
  max-width: 4rem;
  max-height: 4rem;
  @media print {
    max-width: 6rem;
    max-height: 6rem;
  }
`;

export default BrandLogo;
